import { gql } from '@apollo/client';

export const GET_NOTIFICATION_PREFERENCES = gql`
  query getNotificationPreferences {
    getNotificationPreferences {
      content {
        newFlyer
        savedSearch
        upcomingSavedSearch
      }
      deliveryMode {
        email
        push
      }
    }
  }
`;
